import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoDatePicker from '../../components/date-picker/pendo-date-picker.vue.js';
import { addDays } from './utils/helpers.js';

var script = {
  name: 'PendoSupportAccess',
  components: {
    PendoCard,
    PendoIcon,
    PendoButton,
    PendoDatePicker
  },
  props: {
    bodyText: {
      type: String,
      default: 'This gives Pendo Technical Support representatives access to the subscription. If enabled, all support tickets from users in this subscription can be addressed without additional action from an Admin. Select a future date to enable or extend access until.'
    },
    calendarText: {
      type: String,
      default: 'Access enabled through:'
    },
    datePickerValue: {
      type: null,
      default: 0
    },
    datePickerLoading: {
      type: Boolean,
      default: false
    },
    availableStartDate: {
      type: null,
      default: undefined
    },
    availableEndDate: {
      type: null,
      default: undefined
    },
    calendarLimitText: {
      type: String,
      default: 'You can select up to 90 days (3 months) from today’s date.'
    },
    expirationDate: {
      type: null,
      default: null
    },
    currentDate: {
      type: null,
      default: () => new Date()
    }
  },
  computed: {
    headerIconOptions() {
      if (!this.datePickerValue) {
        return {
          headerIcon: {
            type: 'minus-circle-solid',
            stroke: '#fff',
            fill: '#2A2C35'
          },
          headerIconText: 'Off'
        };
      }
      const pickerDate = new Date(this.datePickerValue);
      if (this._expirationDate.getTime() < pickerDate.getTime()) {
        return {
          headerIcon: {
            type: 'check-circle-2-solid',
            stroke: '#fff',
            fill: '#00BA6D'
          },
          headerIconText: 'On'
        };
      }
      return {
        headerIcon: {
          type: 'alert-circle-solid',
          stroke: '#fff',
          fill: '#DBA211'
        },
        headerIconText: 'Expired'
      };
    },
    showAccessButton() {
      return this.headerIconOptions.headerIconText === 'On';
    },
    _expirationDate() {
      if (!this.expirationDate) {
        const currentDate = new Date(this.currentDate);
        const expiration = addDays(currentDate, -1);
        expiration.setHours(23, 59, 0, 0);
        return expiration;
      }
      return new Date(this.expirationDate);
    },
    minAvailableDay() {
      if (this.availableStartDate === null) {
        return null;
      }
      if (!this.availableStartDate) {
        const current = new Date(this.currentDate);
        return addDays(current, 0);
      }
      return this.availableStartDate;
    },
    maxAvailableDay() {
      if (this.availableEndDate === null) {
        return null;
      }
      if (!this.availableEndDate) {
        const current = new Date(this.currentDate);
        return addDays(current, 89);
      }
      return this.availableEndDate;
    }
  },
  methods: {
    changeDate(date) {
      if (!date) {
        return;
      }
      this.$emit('change-date', date);
    },
    accessButtonClick() {
      this.$emit('access-button-click', this._expirationDate);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-support-access.vue2.js.map
